import { compose } from 'recompose';

import PopupView from './PopupView';

export default compose()(PopupView);
